module.exports = __webpack_public_path__ + "245b7cb607ba382289c23aa668786c28.svg";